import { SideBarDef, StatusPanelDef } from "ag-grid-enterprise";

export const defaultColumnFilters = {
  filter: "agMultiColumnFilter",
  filterParams: {
    filters: [
      {
        filter: "agTextColumnFilter",
        display: "accordion",
        filterParams: { buttons: ["apply", "reset"] }
      },
      {
        filter: "agNumberColumnFilter",
        display: "accordion",
        filterParams: { buttons: ["apply", "reset"] }
      },
      {
        filter: "agSetColumnFilter",
        display: "accordion",
        filterParams: { buttons: ["apply", "reset"] }
      }
    ]
  }
} as const;

export const defaultSidebar: {
  sideBar: SideBarDef;
  statusBar: { statusPanels: StatusPanelDef[] };
} = {
  // Side bar
  sideBar: {
    toolPanels: ["columns", "filters"],
    position: "right",
    defaultToolPanel: ""
  },

  // Status bar
  statusBar: {
    statusPanels: [
      {
        statusPanel: "agAggregationComponent",
        statusPanelParams: { aggFuncs: ["avg", "sum", "count"] }
      }
    ]
  }
};
